document.addEventListener('DOMContentLoaded',() => {
  const theToggle = document.getElementById('the_toggle');
  const theText = document.getElementById('the_text');

  // If the text is clamped, display the read more button
  function initOveriewViewMore() {
    var clientHeight = theText.clientHeight;
    var scrollHeight = theText.scrollHeight;
    var isClamped = scrollHeight > clientHeight;

    if (isClamped) {
      theToggle.style.display = 'block';
    } else {
      theToggle.style.display = 'none';
    }
  }

  function handleClick() {
    event.preventDefault();
    if (theText.classList.contains("clamped_text")) {
      theToggle.textContent = "Read Less";
      theText.classList.remove("clamped_text");
      theText.classList.add("expanded_text");
    } else {
      theToggle.textContent = "Read More";
      theText.classList.remove("expanded_text");
      theText.classList.add("clamped_text");
    }
  }

  function updateInventoryDisplay() {
    document.addEventListener('variant:changed', function(event) {
        var variant = event.detail.variant,
        display = document.querySelector('.ProductMeta__Inventory');
        if(display) {
            if (variant.available) {
              display.textContent = 'In Stock'
            } else {
              display.textContent = 'Out of Stock'
            }
        }
    });
  }

  initOveriewViewMore();
  updateInventoryDisplay();
  theToggle.addEventListener('click', handleClick);
  window.addEventListener('resize', initOveriewViewMore);
});


function toggleVariantThumbnails(event) {
  let variant = event;

  let navScroller = document.getElementsByClassName('Product__SlideshowNav--thumbnails')[0];
      navScroller.classList.add('is-hidden');

      if (variant) {
          let sku = variant.sku.toLowerCase(),
              thumbs = document.querySelectorAll('.Product__SlideshowNav .Product__SlideshowNavImage'),
              hasThumb = document.querySelectorAll('.Product__SlideshowNav .Product__SlideshowNavImage[data-color="'+ sku +'"]').length,
              thumbsMobile = document.querySelectorAll('.Product__SlideshowMobileNav .flickity-page-dots .dot');
          var flag = true;
          if (hasThumb) {
              thumbs.forEach( function(thumb,index) {
                  if (sku === thumb.dataset.color.toLowerCase()) {
                      thumb.classList.remove('hidden-tablet-and-up');
                      if(flag) {
                        thumb.click();
                        flag = false;
                      }

                  } else {
                      thumb.classList.add('hidden-tablet-and-up');
                  }
              });
              var mobileFlag = true;
              thumbsMobile.forEach( function(thumb) {
                if (sku === thumb.dataset.color.toLowerCase()) {
                    thumb.classList.remove('hidden-phone','hidden-tablet-and-up');
                    if(mobileFlag) {
                      thumb.click();
                      mobileFlag = false;
                    }
                } else {
                    thumb.classList.add('hidden-phone','hidden-tablet-and-up');
                }
            });
          } else {
            thumbs.forEach( function(thumb) {
                thumb.classList.remove('hidden-tablet-and-up');
            });
            thumbsMobile.forEach( function(thumb) {
                thumb.classList.remove('hidden-phone');
            });
          }
      }
      
      setTimeout(function () {
          navScroller.classList.remove('is-hidden');
      }, 750);

}

function adjustAddToCartButton(){
  // Change Button__SeparatorDot to Button__SeparatorDash
  var separator = document.querySelector('.Button__SeparatorDot');
  if (separator) {
      separator.classList.remove('Button__SeparatorDot');
      separator.classList.add('Button__SeparatorDash');
      separator.textContent = "-";
  }

  // Append .00 after the price in data-money-convertible
  var priceElement = document.querySelector('.ProductForm__AddToCart [data-money-convertible]');
  if (priceElement) {
      var price = priceElement.textContent.trim();
      priceElement.textContent = price + '.00';
  }
}

document.addEventListener('DOMContentLoaded', function() {

  document.addEventListener('variant:changed', function(event) {
    toggleVariantThumbnails(event.detail.variant);
    adjustAddToCartButton();
  });

     // Find the element that contains data about the current variant
     const variantDataElement = document.querySelector('[data-product-json]');
     if (variantDataElement) {
         const jsonData = JSON.parse(variantDataElement.innerHTML);
         const currentVariantId = jsonData.selected_variant_id;
         const currentVariant = jsonData.product.variants.find(variant => variant.id === currentVariantId);
         toggleVariantThumbnails(currentVariant);
     } 
});
